spec_version: '1.1'
id: 1
slug: 01-diagnostico-y-base
titulo: Diagnóstico y base
duracion_min: 90
estado: placeholder
fase_produccion: 0
ultima_actualizacion: '2026-06-15'
prerrequisitos: []
objetivos_aprendizaje:
- id: OA-01.1
  texto: Identificar tus fuentes de ingreso y patrones de gasto
  bloom: ''
- id: OA-01.2
  texto: Calcular tu ratio de ahorro mensual y tu patrimonio neto
  bloom: ''
- id: OA-01.3
  texto: Reconocer en qué perfil financiero estás y por qué
  bloom: ''
- id: OA-01.4
  texto: Definir las prioridades de las próximas etapas
  bloom: ''
glosario: []
secciones:
- tipo: teoria
  archivo: teoria.md
- tipo: quiz-practica
  archivo: quiz-practica.md
- tipo: recursos
  archivo: recursos.md
sub_secciones_teoria:
- id: '1.1'
  titulo: Tu radiografía financiera actual
  duracion_min: 15
- id: '1.2'
  titulo: Ingresos, gastos fijos y gastos variables
  duracion_min: 20
- id: '1.3'
  titulo: La regla 50/30/20 y cuándo no aplica
  duracion_min: 15
- id: '1.4'
  titulo: Calcular tu patrimonio neto
  duracion_min: 15
- id: '1.5'
  titulo: Identificar tu perfil financiero
  duracion_min: 15
- id: '1.6'
  titulo: Próximos pasos según tu perfil
  duracion_min: 10
